import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import api from "../../axiosConfig";
import BxumForm from "./BxumForm";

const BxumCreate = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [initialValues] = useState({ cod: "", descriere: "", zecimale: 0, um_saft: "" });

  const onSubmit = async (form) => {
    try {
      setSubmitting(true);
      await api.post("/bxums", form);
      navigate("/bxums");
    } catch (err) {
      alert("Eroare la creare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="mt-4 p-3">
      <h3>Adaugă unitate de măsură</h3>
      <button type="button" className="btn btn-outline-secondary mb-3" onClick={() => navigate("/bxums")}>Înapoi la listă</button>
      <BxumForm initialValues={initialValues} onSubmit={onSubmit} submitting={submitting} />
    </Card>
  );
};

export default BxumCreate;
